import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from '@coveord/plasma-mantine';
import { Locales } from '../../../strings/Locales.js';
export var EditConfirmationPromptConfirmButton = function EditConfirmationPromptConfirmButton(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Prompt.ConfirmButton, {
        onClick: onClick,
        children: Locales.format('EditConfirmationPrompt.footer.button.save')
    });
};
EditConfirmationPromptConfirmButton.displayName = 'EditConfirmationPrompt.ConfirmButton';

//# sourceMappingURL=EditConfirmationPromptConfirmButton.js.map